"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTextColumnFilterSortConfig = void 0;
const react_1 = require("react");
const ui_components_1 = require("@groupby/ui-components");
const localization_1 = require("../../../../localization");
const useTextColumnFilterSortConfig = () => {
    const { formatMessage: t } = (0, localization_1.useLocalization)();
    const matchOptionsTranslate = (0, react_1.useMemo)(() => ({
        [ui_components_1.TextFilterOperatorTypes.Contains]: t({ key: 'MATCH_OPTION_CONTAINS' }),
        [ui_components_1.TextFilterOperatorTypes.DoesNotContain]: t({ key: 'MATCH_OPTION_DOES_NOT_CONTAIN' }),
        [ui_components_1.TextFilterOperatorTypes.NotEquals]: t({ key: 'MATCH_OPTION_IS_NOT' }),
    }), [t]);
    const getFilterConfig = (0, react_1.useCallback)(() => ({
        filterable: true,
        sortable: true,
        filterOperators: (0, ui_components_1.createTextFilterOperators)({
            operatorLabelMap: matchOptionsTranslate,
            allowedOperators: Object.keys(matchOptionsTranslate),
            inputProps: {},
        }),
    }), [matchOptionsTranslate]);
    return getFilterConfig;
};
exports.useTextColumnFilterSortConfig = useTextColumnFilterSortConfig;
